import React, { createContext, useState, useEffect, useContext } from "react";
import api from "../../services/api";
import useWhatsApps from "../../hooks/useWhatsApps";
import { AuthContext } from "../Auth/AuthContext";

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
  const whatsAppData = useWhatsApps();
  const { loading = false, whatsApps = [] } = whatsAppData || {};
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const initWebphone = async () => {
      try {
        const { data } = await api.get("/call/historical/user/whatsapp");
        const token = data?.whatsapp?.wavoip;
        if (!token) return;

        // Esperar o script CDN carregar
        const waitForWebphone = () => new Promise((resolve) => {
          if (window.wavoipWebphone) return resolve();
          const interval = setInterval(() => {
            if (window.wavoipWebphone) {
              clearInterval(interval);
              resolve();
            }
          }, 200);
        });

        await waitForWebphone();
        const webphoneAPI = await window.wavoipWebphone.render({
          position: "bottom-right",
          theme: "light",
          widget: {
            showWidgetButton: false,
          },
        });

        webphoneAPI.device.add(token, true);
        console.log("Wavoip webphone inicializado com token:", token);
      } catch (err) {
        console.error("Erro ao inicializar webphone:", err);
      }
    };
    initWebphone();
  }, []);

  return (
    <WhatsAppsContext.Provider value={{ whatsApps, loading }}>
      {children}
    </WhatsAppsContext.Provider>
  );
};

export { WhatsAppsContext, WhatsAppsProvider };